/* eslint-disable no-unused-vars */

import React, { useEffect, useState } from "react";
import {
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  Paper,
  Grid,
  FormControl,
  Skeleton,
  Button,
  Alert,
  InputLabel,
  Select,
  Input
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { Link, useLocation } from "react-router-dom";
import TableFooter from "@mui/material/TableFooter";
import LocalDateSelector from "../../common/LocalDateSelector";
import PageTitle from "../../common/PageTitle";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from "react-router-dom";
import Loader from "../../common/Loader"
import { deleteAPI, getAPI, getExportAPI, getExportPdfAPI, patchAPI, uploadAPI } from "../../network";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import GetAppRoundedIcon from '@mui/icons-material/GetAppRounded';

import EmptyTable from "../../common/EmptyTable";
import { useDispatch, useSelector } from "react-redux";
import { checkAuthority, tableHeader, tableData, formatDate, timeFormat, formatDatePost } from "../../utils";
import "./style.css";
import { BASE_URL } from "../../../constant";




export default function TaskList({ route, navigation }) {
  const dispatch = useDispatch();
  const navigateTo = useNavigate();

  const [deleteId, setDeleteId] = useState('');
  const [open, setOpen] = useState(false)
  const [show, setShow] = useState(false)
  const [status2, setStatus2] = useState('')
  const [loader, setLoader] = useState(false)
  const [tasks, setTasks] = useState([])
  const [edit, setEdit] = useState('')
  const [expanded, setExpanded] = useState("panel_0");
  const location = useLocation();

  const [page, setPage] = useState(0);
  const [perPages, setPerPages] = useState([5, 10, 25, 50]);
  const [perPage, setPerPage] = useState(10)


  const [filter, setFilter] = useState({
    siteId: '',
    time: null,
    startDate: null,
    endDate: null,
  })
  const [status, setStatus] = useState({
    answer1: '',
    answer2: '',
    answer3: '',
    notes: '',
    status: '',
    picture: ''
  })

  var taskval = location.state

  const clearStatus = () => {
    setStatus({
      answer1: '',
      answer2: '',
      answer3: '',
      notes: '',
      status: '',
      picture: ''
    });
  };

  const handleChangeRowsPerPage = (event) => {
    console.log(event.target.value)
    setPerPage(event.target.value)
    setPage(0);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    getTasks()
    // getTasks()
  }, []);

  const getTasks = async (sId = null, sTime = null, sDate = null, eDate = null, stat) => {

    sId = sId !== null ? sId : filter.siteId;
    sTime = sTime !== null ? sTime : filter.time;
    sDate = sDate !== null ? sDate : filter.startDate;
    eDate = eDate !== null ? eDate : filter.endDate;

    var url = ''
    var start = true;
    if (sId !== '' && sId !== null) {
      url += (start ? '?' : '&') + `siteId=${sId}`
      start = false;
    }
    if (sTime !== '' && sTime !== null) {
      url += (start ? '?' : '&') + `timeDue=${timeFormat(sTime)}`
      start = false;
    }
    if (sDate !== '' && sDate !== null) {
      url += (start ? '?' : '&') + `startDate=${formatDatePost(sDate)}`
      start = false;
    }
    if (eDate !== '' && eDate !== null) {
      url += (start ? '?' : '&') + `endDate=${formatDatePost(eDate)}`
      start = false;
    }
    setLoader(true)
    if (stat) {
      let data = await getAPI(`/tasks/group-by-id/${taskval}?status=${stat}` + url)
      if (data) {
        setTasks(data)
      }
    } else {
      let data = await getAPI(`/tasks/group-by-id/${taskval}` + url)
      if (data) {
        setTasks(data)
      }

    }

    setLoader(false)
  }


  const statuses = [
    {
      label: "None",
      value: "none"
    },
    {
      label: "Reschedule",
      value: "reschedule"
    },
    {
      label: "On Hold",
      value: "on hold"
    },
    {
      label: "Completed",
      value: "completed"
    },
    {
      label: "Partially Completed",
      value: "partially completed"
    }
  ]; 


  const deleteClick = (id) => {
    setDeleteId(id);
    setOpen(true)
  }

  const EditClick = (id) => {
    setShow(true)
    setEdit(id)
  }
  const handleChange = (event) => {
    setStatus(prevState => ({
      ...prevState,
      status: event.target.value,
    }))
  };
  const changeStatus = (e) => {
    setStatus2(e.target.value)
    getTasks(null, null, null, null, e.target.value)
  }

  const handleDelete = async (siteId = null) => {

    setLoader(true);
    let empty = await deleteAPI(`/tasks/${deleteId}`);
    if (empty) {
      setOpen(false);
      getTasks()

    }
    setLoader(false);
  }

  const handleEdit = async () => {
    const payload = status
    // const payload = {
    //   "status": status.status
    // }
    setLoader(true);
    let empty = await patchAPI(`/tasks/${edit}`, payload);
    if (empty) {
      setShow(false);
      getTasks()
    }
    clearStatus()
    setLoader(false);
  }

  const AssessExp2 = async (id) => {
    setLoader(true)

    let sDate = filter.startDate;
    let eDate = filter.endDate;

    var url = ''
    var start = true;

    if (sDate !== '' && sDate !== null) {
      url += (start ? '&' : '&') + `startDate=${formatDatePost(sDate)}`
      start = false;
    }
    if (eDate !== '' && eDate !== null) {
      url += (start ? '&' : '&') + `endDate=${formatDatePost(eDate)}`
      start = false;
    }
    let data = await getExportAPI(`${BASE_URL}/export/file/tasks?groupId=${taskval}` + url, `Task Details`)
    setLoader(false)
  }
  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      setLoader(true);
      const url = await uploadAPI(file);
      if (url) {
        setStatus((prev) => ({ ...prev, picture: url }));
        // setAlert({ open: true, message: "Image uploaded successfully", severity: "success" });
      }
      setLoader(false);
    }
  };
  return (



    <Box>
      <Loader loader={loader} />
      <PageTitle title="Task Details" />
      <Box ml={1}>
        <FormControl
          sx={{
            width: "100%",
          }}
        >
          <Grid sx={{ my: "1rem" }} container spacing={3} width={"100%"}>
            {
              checkAuthority('VIEW_TASKS') &&
              <>
                <Grid item xs={6} md={6} lg={3}>
                  <LocalDateSelector
                    title="Start Date "
                    value={filter.startDate}
                    placeholder="Select Time"
                    onChange={(date) => {
                      setFilter({
                        ...filter,
                        startDate: date
                      })
                      getTasks(null, null, date)
                    }}
                  />
                </Grid>
                <Grid item xs={6} md={6} lg={3}>
                  <LocalDateSelector
                    title="End Date "
                    value={filter.endDate}
                    placeholder="Select Time"
                    onChange={(date) => {
                      setFilter({
                        ...filter,
                        endDate: date
                      })
                      getTasks(null, null, null, date)
                    }}
                  />
                </Grid>
                <Grid item xs={6} md={6} lg={3}>

                  <Button variant="contained" style={{ backgroundColor: "#75859D" }} sx={{ height: 50, width: '17.5rem' }} onClick={() => AssessExp2()}>
                    <GetAppRoundedIcon /> &nbsp; &nbsp;
                    Export
                  </Button>
                </Grid>

              </>
            }

          </Grid>
        </FormControl>

        <TableContainer component={Paper} style={{ maxWidth: 600, margin: "20px auto", padding: "20px" }}>
          <Table aria-label="custom table">
            <TableBody>
              <TableRow>
                <TableCell component="th" scope="row" style={{ fontWeight: "bold" }}>
                  Title
                </TableCell>
                <TableCell>{tasks[0]?.title}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row" style={{ fontWeight: "bold" }}>
                  Site
                </TableCell>
                <TableCell>{tasks[0]?.siteId?.name}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row" style={{ fontWeight: "bold" }}>
                  Due Date
                </TableCell>
                <TableCell>
                  {new Date(tasks[0]?.endDate).toLocaleDateString("en-uk", {
                    year: "numeric",
                    month: "short",
                    day: "2-digit",
                  })}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row" style={{ fontWeight: "bold" }}>
                  Work Order Number
                </TableCell>
                <TableCell>{tasks[0]?.workOrderNo}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row" style={{ fontWeight: "bold" }}>
                  Vendor Name
                </TableCell>
                <TableCell>{tasks[0]?.vendor?.name}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row" style={{ fontWeight: "bold" }}>
                  Service Category L1
                </TableCell>
                <TableCell>{tasks[0]?.serviceL1}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row" style={{ fontWeight: "bold" }}>
                  Service Category L2
                </TableCell>
                <TableCell>{tasks[0]?.serviceL2}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row" style={{ fontWeight: "bold" }}>
                  Service Category L3
                </TableCell>
                <TableCell>{tasks[0]?.serviceL3}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row" style={{ fontWeight: "bold" }}>
                  Task Description
                </TableCell>
                <TableCell>{tasks[0]?.description}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row" style={{ fontWeight: "bold" }}>
                  Role
                </TableCell>
                <TableCell>{tasks[0]?.role?.name}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        {
          checkAuthority('VIEW_TASKS') &&
          <Box display="flex" sx={{ my: "3rem" }}>
            <TableContainer component={Paper}>

              <Table
                sx={{ minWidth: "auto" }}
                aria-label="custom pagination table"
                className="responsive-table"
              >
                <TableHead>
                  <TableRow className="table-header">
                    <TableCell align="left" component="th" sx={tableHeader}>
                      Task Date
                    </TableCell>
                    <TableCell align="left" component="th" sx={tableHeader}>
                      Due Time
                    </TableCell>
                    <TableCell align="left" component="th" sx={tableHeader}>
                      Suffered Injury
                    </TableCell>
                    <TableCell align="left" component="th" sx={tableHeader}>
                      Task Completed
                    </TableCell>
                    <TableCell align="left" component="th" sx={tableHeader}>
                      Reportable Issue
                    </TableCell>
                    <TableCell align="left" component="th" sx={tableHeader}>
                      Task Status
                    </TableCell>
                    <TableCell align="left" component="th" sx={tableHeader}>
                      Notes
                    </TableCell>
                    <TableCell align="left" component="th" sx={tableHeader}>
                      Media
                    </TableCell>
                    <TableCell align="left" component="th" sx={tableHeader}>
                      Signature
                    </TableCell>
                    <TableCell align="left" component="th" sx={tableHeader}>
                      Updated By
                    </TableCell>

                    <TableCell align="center" component="th" sx={tableHeader}>
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tasks.slice(page * perPage, page * perPage + perPage).map((task, index) => (
                    <TableRow key={index}>

                      <TableCell align="left" sx={tableData}>
                        {new Date(task?.taskDate).toLocaleDateString("en-uk", {
                          year: "numeric",
                          month: "short",
                          day: "2-digit",
                        })}
                      </TableCell>

                      <TableCell align="left" sx={tableData}>
                        {task?.timeDue}
                      </TableCell>
                      <TableCell align="left" sx={tableData}>
                        {task?.taskLogs[0]?.answers[0] ? task?.taskLogs[0]?.answers[0] : ""}
                      </TableCell>
                      <TableCell align="left" sx={tableData}>
                        {task?.taskLogs[0]?.answers[1] ? task?.taskLogs[0]?.answers[1] : ""}
                      </TableCell>
                      <TableCell align="left" sx={tableData}>
                        {task?.taskLogs[0]?.answers[2] ? task?.taskLogs[0]?.answers[2] : ""}
                      </TableCell>
                      <TableCell align="left" sx={tableData}>
                        {task?.status}
                      </TableCell>
                      <TableCell align="left" sx={tableData}>
                        {task?.taskLogs[0]?.notes ?
                          <div
                            title={task?.taskLogs[0]?.notes} // Tooltip for accessibility
                          >
                            <span>
                              {task?.taskLogs[0]?.notes.split(" ").slice(0, 10).join(" ")}
                              <span style={{ display: "none" }} className="hover-reveal">
                                {" "}{task?.taskLogs[0]?.notes.split(" ").slice(10).join(" ")}
                              </span>
                            </span>
                          </div>
                          : ""}
                      </TableCell>
                      <TableCell>
                        {task?.taskLogs[0]?.media && (
                          <a href={task?.taskLogs[0]?.media} target="_blank" rel="noreferrer">
                            <img src={task?.taskLogs[0]?.media} alt="preview" style={{ width: 40 }} />
                          </a>
                        )}
                      </TableCell>
                      <TableCell>
                        {task?.taskLogs[0]?.signature && (
                          <a href={task?.taskLogs[0]?.signature} target="_blank" rel="noreferrer">
                            <img src={task?.taskLogs[0]?.signature} alt="preview" style={{ width: 40 }} />
                          </a>
                        )}
                      </TableCell>
                      <TableCell align="left" sx={tableData}>
                        {task?.updateBy || 'N/A'}
                      </TableCell>
                      <TableCell align="center" sx={{ textAlign: 'center', tableData }}>
                        {
                          checkAuthority('CHANGE_TASK_STATUS') &&
                          <Button className="btn-div" variant="outlined" color="info" sx={{ mx: 1 }}
                            onClick={() => EditClick(task?._id)}>
                            <EditIcon className="" />
                          </Button>
                        }
                        {
                          checkAuthority('VIEW_TASKS') &&
                          <Button className="btn-div" variant="outlined" color="error" sx={{ mx: 1 }}
                            onClick={() => deleteClick(task?._id)}>

                            <DeleteIcon className="" />
                          </Button>
                        }

                      </TableCell>
                    </TableRow>

                  ))}

                  {
                    tasks.length === 0 &&
                    <EmptyTable colSpan={6} />
                  }
                </TableBody>
                <TableFooter>
                  <TableRow >
                    <TablePagination
                      align="right"
                      rowsPerPageOptions={perPages}
                      colSpan={7}
                      count={tasks.length}
                      rowsPerPage={perPage}
                      page={page}
                      SelectProps={{
                        inputProps: {
                          'aria-label': 'rows per page',
                        },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    // ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </Box>
        }
        <Dialog open={show} onClose={() => setShow(false)} fullWidth>
          <DialogTitle sx={{ textAlign: 'center', mb: 8 }}>Edit Task</DialogTitle>
          <DialogContent>

            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel id="site-label" >Have you suffered any injury or near miss?</InputLabel>
              <Select
                labelId="site-label"
                id="site-select"
                value={status.answer1}
                label="Have you suffered any injury or near miss?"
                onChange={(event) => setStatus(prevState => ({
                  ...prevState,
                  answer1: event.target.value,
                }))}

              >

                <MenuItem value={"Yes"} >Yes</MenuItem>
                <MenuItem value={"No"} >No</MenuItem>
                <MenuItem value={"NA"} >NA</MenuItem>
              </Select>
            </FormControl>
            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel id="site-label" >Have you completed all the required tasks?</InputLabel>
              <Select
                labelId="site-label"
                id="site-select"
                value={status.answer2}
                label="Have you completed all the required tasks?"
                onChange={(event) => setStatus(prevState => ({
                  ...prevState,
                  answer2: event.target.value,
                }))}
              >

                <MenuItem value={"Yes"} >Yes</MenuItem>
                <MenuItem value={"No"} >No</MenuItem>
                <MenuItem value={"NA"} >NA</MenuItem>


              </Select>
            </FormControl>

            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel id="site-label" >Is there a reportable issue? Select one from below</InputLabel>
              <Select
                labelId="site-label"
                id="site-select"
                value={status.answer3}
                label="Is there a reportable issue? Select one from below"
                onChange={(event) => setStatus(prevState => ({
                  ...prevState,
                  answer3: event.target.value,
                }))}
              >

                <MenuItem value={"None"} >None</MenuItem>
                <MenuItem value={"Defect"} >Defect</MenuItem>
                <MenuItem value={"Critical Defect"} >Critical Defect</MenuItem>
                <MenuItem value={"Non Critical Defect"} >Non Critical Defect</MenuItem>
                <MenuItem value={"Non Conformance"} >Non Conformance</MenuItem>
              </Select>
            </FormControl>
            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel id="site-label" >Status</InputLabel>
              <Select
                labelId="site-label"
                id="site-select"
                value={status.status}
                label="Status"
                onChange={handleChange}

              >
                {
                  statuses.map((item, index) => (
                    <MenuItem value={item.value} key={index}>{item.label}</MenuItem>
                  ))
                }
              </Select>
            </FormControl>
            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel htmlFor="my-input">Notes</InputLabel>
              <Input id="my-input" aria-describedby="my-helper-text" onChange={(event) => setStatus(prevState => ({
                ...prevState,
                notes: event.target.value,
              }))}
                value={status.notes}
              />
            </FormControl>
            <Button variant="contained" component="label" sx={{ mt: 2 }}>
              Upload Picture
              <input type="file" hidden accept="image/*" onChange={handleImageUpload} />
            </Button>
            {status.picture && (
              <Box mt={2}>
                <img src={status.picture} alt="uploaded" style={{ maxWidth: "100px" }} />
              </Box>
            )}
          </DialogContent>
          <DialogActions sx={{ mx: 2, mb: 4 }}>
            <Button onClick={handleEdit} variant="contained" color="primary">Update</Button>
            <Button onClick={() => setShow(false)} variant="outlined">Cancel</Button>
          </DialogActions>
        </Dialog>


        <Dialog open={open} onClose={() => setOpen(false)} fullWidth={true}>
          <DialogTitle sx={{ mb: 4, textAlign: "center" }}>Delete Task</DialogTitle>

          <DialogContent>
            <Box
              component="form"
              sx={{
                '& .MuiTextField-root': { my: 2, width: '100%' },
              }}
              noValidate
              autoComplete="off"
            >

              <h3 style={{ textAlign: 'left', fontWeight: 'bold' }}>Do you want's to delete this task</h3>
            </Box>
          </DialogContent>
          <DialogActions sx={{ mb: 2, mx: 4 }}>
            <Button onClick={handleDelete} variant="contained" color="error">Delete</Button>
            <Button onClick={() => setOpen(false)} variant="outlined">Cancel</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>

  );
}
